import { colorMapper, devices, mapper, sizeMapper } from "src/styles";

import { theme } from "src/styles";
import styled, { css } from "styled-components";

interface TextDisplayProps {
  align?: string;
  block?: boolean;
  color?: string;
  cursor?: string;
  desktopMargin?: string;
  flex?: boolean;
  flexAlignCenter?: boolean;
  fontStyle?: string;
  hasBackground?: boolean;
  hasIcon?: boolean;
  justifyContent?: string;
  lineHeight?: string;
  margin?: string;
  maxWidth?: number;
  minWidth?: number;
  padding?: string;
  position?: string;
  singleLine?: boolean;
  size?: string;
  tabletMargin?: string;
  underlined?: boolean;
  uppercase?: boolean;
  weight?: string;
  zIndex?: string;
}

const TextDisplay = styled.span<TextDisplayProps>`
  margin: ${(props) => sizeMapper(props.margin, "no")};
  padding: ${(props) => sizeMapper(props.padding, "no")};
  /* font-size = body font size * scaling factor */

  font-size: ${(props) =>
    mapper(
      props.size,
      {
        xxxSmall: "0.5rem", // 8px
        xxSmall: "0.688rem", // 11px
        xSmall: "0.75rem", // 12px
        small: "0.8rem", // 12px
        medium: "0.9rem", // 14px
        large: "1rem", // 16px
        xLarge: "1.2rem", // 18px
        xxLarge: "1.5rem", // 24px
        xxxLarge: "1.7rem", // 27px
        extraLarge: "2.5rem", // 40px
      },
      "medium"
    )};

  b {
    font-weight: 500;
  }

  ${(props) =>
    props.cursor &&
    css`
      cursor: ${props.cursor};
    `};

  ${(props) =>
    props.lineHeight &&
    css`
      line-height: ${props.lineHeight};
    `};

  ${(props) =>
    props.block &&
    css`
      display: block;
    `};

  ${(props) =>
    props.flex &&
    css`
      display: flex;
      align-items: ${props.flexAlignCenter ? "center" : "baseline"};
    `};

  ${(props) =>
    props.weight &&
    css`
      font-weight: ${() => mapper(props.weight, { light: 300, normal: 400, medium: 500 })};
    `};

  ${(props) =>
    props.align &&
    css`
      text-align: ${() =>
        mapper(props.align, { left: "left", center: "center", right: "right" }, "left")};
    `};

  ${(props) =>
    props.singleLine &&
    css`
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    `};

  ${(props) =>
    props.color &&
    css`
      color: ${colorMapper(props)};
    `};

  ${(props) =>
    props.hasBackground &&
    css`
      background: ${theme.brandPrimary};
      color: #fff;
      padding: 4px 6px;
      width: calc(100% - 4px);
      margin: 0 2px;
      text-align: center;
      position: absolute;
      bottom: 2px;
      left: 0;
    `};

  ${(props) =>
    props.underlined &&
    css`
      text-decoration: underline;
    `};

  ${(props) =>
    props.uppercase &&
    css`
      text-transform: uppercase;
    `};
  ${(props) =>
    props.fontStyle &&
    css`
      font-style: ${props.fontStyle};
    `};

  ${(props) =>
    props.minWidth &&
    css`
      min-width: ${props.minWidth}px;
    `};

  ${(props) =>
    props.maxWidth &&
    css`
      max-width: ${props.maxWidth}px;
    `};

  ${(props) =>
    props.justifyContent &&
    css`
      justify-content: ${props.justifyContent};
    `};

  ${(props) =>
    props.position &&
    css`
      position: ${props.position};
    `};

  ${(props) =>
    props.zIndex &&
    css`
      z-index: ${props.zIndex};
    `};

  //fontSize increase by 1.3 for tablet
  ${devices.tablet} {
    font-size: ${(props) =>
      mapper(
        props.size,
        {
          xxxSmall: "0.5rem", // 8px
          xxSmall: "0.688rem", // 11px
          xSmall: "0.75rem", // 12px
          small: "0.8rem", // 12px
          medium: "0.9rem", // 14px
          large: "1rem", // 16px
          xLarge: "1.2rem", // 19px
          xxLarge: "1.4rem", // 22px
          xxxLarge: "1.5rem", // 24px
          extraLarge: "3.5rem", // 56px
        },
        "medium"
      )};

    ${(props) =>
      props.tabletMargin &&
      css`
        margin: ${sizeMapper(props.tabletMargin, "no")};
      `}
  }

  ${devices.desktop} {
    font-size: ${(props) =>
      mapper(
        props.size,
        {
          xxxSmall: "0.5rem", // 8px
          xxSmall: "0.688rem", // 11px
          xSmall: "0.75rem", // 12px
          small: "0.875rem", // 14px
          medium: "1rem", // 16px
          large: "1.5rem", // 24px
          xLarge: "2rem", // 32px
          xxLarge: "2.25rem", // 36px
          xxxLarge: "4.5", // 72px
        },
        "medium"
      )};
    // line height is by 1.2 higher than font size
    line-height: ${(props) =>
      !props.lineHeight &&
      mapper(
        props.size,
        {
          xxxSmall: "0.6rem", // 9px
          xxSmall: "0.8rem", // 12px
          xSmall: "0.9rem", // 14px
          small: "1.05rem", // 16px
          medium: "1.2rem", // 19px
          large: "1.8rem", // 28px
          xLarge: "2.4rem", // 38px
          xxLarge: "2.7rem", // 43px
          xxxLarge: "5.4rem", // 86px
        },
        "medium"
      )};

    ${(props) =>
      props.desktopMargin &&
      css`
        margin: ${sizeMapper(props.desktopMargin, "no")};
      `}
  }
`;

export default TextDisplay;
